import {Injectable} from "@angular/core";
import {HttpRepository} from "./http.repository";
import {Observable} from "rxjs";
import {ScreenAccess} from "../interfaces/rest/ScreenAccess";
import {GlobalConfig} from "../configs/GlobalConfig";

@Injectable()
export class ScreenAccessRepository {

  constructor(private httpRepository: HttpRepository) {

  }

  getScreenAccessAndItsChildren(accessName: string): Observable<Array<ScreenAccess>> {
    return this.httpRepository.get(`${GlobalConfig.endpoints.screenAccess}/${accessName}`);
  }
}
